import { useEffect, useState } from 'react';
import { PageHeader } from '../ui/PageHeader';
import { Panel } from '../ui/Panel';
import { LoadFailed } from '../ui/LoadState';
import { fetchAuditLog } from '../adminApi';
import { dateOf, timeOf } from '../../core/format/dates';
import type { AuditPage, AuditQuery } from '../../core/types/team';
type Cls = NonNullable<AuditQuery['cls']>;
const clsLabel: Record<Cls, string> = {
  C: 'Klantgegevens',
  D: 'Geld',
  E: 'Toegang'
};

/** Logboek (§10.7): wie deed wat, nieuwste eerst. Alleen lezen; regels worden nooit gewijzigd. */
export function AuditLog() {
  const [cls, setCls] = useState<Cls | ''>('');
  const [page, setPage] = useState(1);
  const [data, setData] = useState<AuditPage | null>(null);
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const ctrl = new AbortController();
    setStatus('loading');
    fetchAuditLog({
      page,
      ...(cls ? {
        cls
      } : {})
    }, {
      signal: ctrl.signal
    }).then(r => {
      setData(r);
      setStatus('ready');
    }).catch(() => {
      if (!ctrl.signal.aborted) setStatus('error');
    });
    return () => ctrl.abort();
  }, [cls, page, attempt]);
  return <div data-id="element-535" data-mp="3id86nunyhopc">
      <PageHeader title="Logboek" description="Wie wat deed in het beheer. Regels worden nooit gewijzigd of gewist." data-id="element-536" data-mp="3idgjjmk2wu0j" />
      <div className="mb-4" data-id="element-537" data-mp="3mf247u2uucla">
        <label className="inline-flex items-center gap-2 text-[13px] text-muted" data-id="element-538" data-mp="dwxd0h50aydr">
          Soort
          <select value={cls} onChange={e => {
          setCls(e.target.value as Cls | '');
          setPage(1);
        }} className="rounded-md border border-line bg-white px-2 py-1.5 text-[14px] text-ink" data-id="element-539" data-mp="ix1rk1mctj1c">
            <option value="" data-id="element-540" data-mp="94cl5l5nuvcv">Alles</option>
            {(Object.keys(clsLabel) as Cls[]).map(c => <option key={c} value={c} data-id="element-541" data-mp="11mzzmhq5jc4z">
                {clsLabel[c]}
              </option>)}
          </select>
        </label>
      </div>

      {status === 'error' && !data ? <LoadFailed title="Het logboek kon niet laden" onRetry={() => setAttempt(n => n + 1)} data-id="element-542" data-mp="1bgnrmwmj0s1t" /> : <Panel title="Gebeurtenissen" description={data ? `${data.total} in totaal` : undefined} flush data-id="element-543" data-mp="12ibvkf2w521z">
          <div aria-busy={status === 'loading'} data-id="element-544" data-mp="xjhaf6hgb1ep">
            {!data ? <p className="px-4 py-8 text-center text-[13px] text-muted sm:px-5" data-id="element-545" data-mp="xlldjm7izwdx">Laden…</p> : data.entries.length === 0 ? <p className="px-4 py-8 text-center text-[13px] text-muted sm:px-5" data-id="element-546" data-mp="nsw7j6uqvapz">Nog niets vastgelegd.</p> : <ul className="divide-y divide-line" data-id="element-547" data-mp="jsm15t31iial">
                {data.entries.map(e => <li key={e.id} className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 px-4 py-3 text-[14px] sm:px-5" data-id="element-548" data-mp="eu0w9gcufaft">
                    <span className="text-ink" data-id="element-549" data-mp="9vh8rbilpqlc">
                      {e.action}
                      <span className="text-muted" data-id="element-550" data-mp="4vbnqe6u72c8"> · {e.target.label}</span>
                    </span>
                    <span className="text-[12px] text-muted" data-id="element-551" data-mp="3qy3n7ig9avvz">
                      {e.name} · {`${dateOf(e.at)} ${timeOf(e.at)}`.trim()}
                      {e.device ? ` · ${e.device}` : ''}
                    </span>
                  </li>)}
              </ul>}
          </div>
        </Panel>}

      {data && data.pageCount > 1 && <nav aria-label="Pagina's" className="mt-4 flex items-center justify-end gap-3 text-[13px]" data-id="element-552" data-mp="386uaz1f3pt0p">
          <button type="button" disabled={page <= 1} onClick={() => setPage(p => p - 1)} className="min-h-[44px] px-3 text-ink disabled:opacity-40" data-id="element-553" data-mp="3d5e17e0q9qyv">
            Vorige
          </button>
          <span className="text-muted" data-id="element-554" data-mp="3mvh01uuj5z54">
            {data.page} / {data.pageCount}
          </span>
          <button type="button" disabled={page >= data.pageCount} onClick={() => setPage(p => p + 1)} className="min-h-[44px] px-3 text-ink disabled:opacity-40" data-id="element-555" data-mp="2pdyqawuvy1c0">
            Volgende
          </button>
        </nav>}
    </div>;
}